"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map = require("lodash/map");

var _map2 = _interopRequireDefault(_map);

var _min = require("lodash/min");

var _min2 = _interopRequireDefault(_min);

var _max = require("lodash/max");

var _max2 = _interopRequireDefault(_max);

var _each = require("lodash/each");

var _each2 = _interopRequireDefault(_each);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = {};

self.isRetina = function () {
    return false;
};

self.isAndroid = function () {
    return false;
};

self.isIE = function () {
    return (/Edge\/|Trident\/|MSIE /.test(window.navigator.userAgent)
    );
};

self.isIosSafari = function () {
    var isStandalone = window.navigator.standalone,
        userAgent = window.navigator.userAgent.toLowerCase(),
        isSafari = /safari/.test(userAgent),
        isIos = /iphone|ipod|ipad/.test(userAgent);

    if (isIos) {
        if (!isStandalone && isSafari) {
            // Browser
            return true;
        } else if (isStandalone && !isSafari) {
            // Standalone
            return true;
        } else if (!isStandalone && !isSafari) {
            // UIWebView
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    };
};

self.isSafari = function () {
    return self.isIosSafari() || navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
};

self.getMobileSafariVersion = function () {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
};

self.isMobileWeb = function () {

    // Code taken from: http://detectmobilebrowsers.com/
    return function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) return true;else return false;
    }(navigator.userAgent || navigator.vendor || window.opera);
};

self.padPrice = function (price) {
    if (price % 100 === 0) return "" + price / 100;

    var priceCent = self.pad(Math.abs(price) % 100, 2);

    if (price < 0) {
        return '-' + Math.abs(parseInt(price / 100)) + "." + priceCent;
    } else {
        return parseInt(price / 100) + "." + priceCent;
    }
};

self.trim = function (str) {
    if (str === null) {
        return null;
    }
    str = str.replace(/^\s*/, "").replace(/\s*$/, "");
    return str.length > 0 ? str : null;
};

var emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
self.validateEmail = function (str) {
    if (str === null) return null;

    if (str.match(emailPattern) === null) {
        return null;
    }
    return str.toLowerCase();
};

self.pad = function (num, totalChars) {
    var pad = '0';
    num = num + '';
    while (num.length < totalChars) {
        num = pad + num;
    }
    return num;
};

// Ratio is between 0 and 1
var changeColor = function changeColor(color, ratio, darker) {
    var difference = Math.round(ratio * 255) * (darker ? -1 : 1),
        minmax = darker ? Math.max : Math.min,
        decimal = color.replace(/^#?([a-z0-9][a-z0-9])([a-z0-9][a-z0-9])([a-z0-9][a-z0-9])/i, function () {
        return parseInt(arguments[1], 16) + ',' + parseInt(arguments[2], 16) + ',' + parseInt(arguments[3], 16);
    }).split(/,/);
    return ['#', self.pad(minmax(parseInt(decimal[0], 10) + difference, 0).toString(16), 2), self.pad(minmax(parseInt(decimal[1], 10) + difference, 0).toString(16), 2), self.pad(minmax(parseInt(decimal[2], 10) + difference, 0).toString(16), 2)].join('');
};

function saturate(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

function colorElementToString(value) {
    return self.pad(saturate(value, 0, 255).toString(16), 2);
}

self.alpha = function (color, alphaRatio) {
    if (typeof color === "undefined") return undefined;
    var alphaValue = Math.round(255 * alphaRatio);
    return "#" + colorElementToString(alphaValue) + color.substr(1);
};

self.lighterColor = function (color, ratio) {
    if (!color) return undefined;
    return changeColor(color, ratio, false);
};

self.darkerColor = function (color, ratio) {
    if (!color) return undefined;
    var val = changeColor(color, ratio, true);
    return val;
};

/** Converts numeric degrees to radians */
if (typeof Number.prototype.toRad === "undefined") {
    Number.prototype.toRad = function () {
        return this * Math.PI / 180;
    };
}

self.calculateDistance = function (p1, p2) {

    var lat1 = p1.latitude;
    var lat2 = p2.latitude;
    var lon1 = p1.longitude;
    var lon2 = p2.longitude;

    var R = 6371; // km
    var dLat = (lat2 - lat1).toRad();
    var dLon = (lon2 - lon1).toRad();
    var lat1 = lat1.toRad();
    var lat2 = lat2.toRad();

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
};

self.latLngToLatitudeLongitude = function (latLng) {
    return { latitude: latLng.lat, longitude: latLng.lng };
};

self.getPrivateDocumentsDirectory = function () {
    return null;
};

self.getBoundsZoomLevel = function (bounds, mapDim) {
    var WORLD_DIM = { height: 256, width: 256 };
    var ZOOM_MAX = 21;

    function latRad(lat) {
        var sin = Math.sin(lat * Math.PI / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }

    function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    }

    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();

    var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

    var lngDiff = ne.lng() - sw.lng();
    var lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;

    var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
    var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

    return Math.min(latZoom, lngZoom, ZOOM_MAX);
};

self.getStaticGoogleMap = function (_points, mapDim, language) {
    // google.maps.latlng objects have .lat and .lng as functions, whereas anyone just
    // sending coords would send them as numbers, so this should work either way
    var points = (0, _map2.default)(_points, function (point) {
        return {
            lat: typeof point.lat === "function" ? point.lat() : point.lat,
            lng: typeof point.lng === "function" ? point.lng() : point.lng
        };
    });

    var bounds = {
        getNorthEast: function getNorthEast() {
            return {
                lat: function lat() {
                    return (0, _min2.default)((0, _map2.default)(points, function (pt) {
                        return pt.lat;
                    }));
                },
                lng: function lng() {
                    return (0, _min2.default)((0, _map2.default)(points, function (pt) {
                        return pt.lng;
                    }));
                }
            };
        },
        getSouthWest: function getSouthWest() {
            return {
                lat: function lat() {
                    return (0, _max2.default)((0, _map2.default)(points, function (pt) {
                        return pt.lat;
                    }));
                },
                lng: function lng() {
                    return (0, _max2.default)((0, _map2.default)(points, function (pt) {
                        return pt.lng;
                    }));
                }
            };
        }
    };

    var mapZoom = points.length > 1 ? self.getBoundsZoomLevel(bounds, mapDim) : 15;
    var mapCenter = {
        lat: (bounds.getNorthEast().lat() + bounds.getSouthWest().lat()) / 2,
        lng: (bounds.getNorthEast().lng() + bounds.getSouthWest().lng()) / 2
    };

    var mapParams = [
    //        {key: "client",          val: 'gme-wixcomltd2'},
    { key: "language", val: language }, { key: "visual_refresh", val: true }, { key: "size", val: mapDim.width + "x" + mapDim.height }, { key: "maptype", val: "roadmap" }, { key: "sensor", val: false }, { key: "center", val: mapCenter.lat + ',' + mapCenter.lng }, { key: "zoom", val: mapZoom }];

    (0, _each2.default)(points, function (point) {
        mapParams.push({ key: "markers", val: "color:red|" + point.lat + "," + point.lng });
    });

    mapParams = (0, _map2.default)(mapParams, function (param) {
        return encodeURIComponent(param.key) + "=" + encodeURIComponent(param.val);
    }).join("&");

    return "https://maps.googleapis.com/maps/api/staticmap?" + mapParams;
};

self.getRootDirectory = function () {
    return null;
};

self.getResourcesDirectory = function () {
    return null;
};

self.isTiIos7Bug = function () {
    return false;
};

self.cleanHtmlString = function (str) {

    if (!str) return null;

    // Replace known tags (some with mistakes.. bad Sefer) - replace br with newline
    str = str.replace(/<br>/gi, "_!_BR_!_").replace(/<br\/>/gi, "_!_BR_!_").replace(/<br \/>/gi, "_!_BR_!_").replace(/<\/br>/gi, "_!_BR_!_");

    // Replace <u> with a marker later replaced back
    str = str.replace(/<u>/gi, "_!_U_!_").replace(/<\/u>/gi, "_!_/U_!_");

    // Replace <b> with a marker later replaced back
    str = str.replace(/<b>/gi, "_!_B_!_").replace(/<\/b>/gi, "_!_/B_!_");

    // If web version...
    if (typeof window !== 'undefined') {

        // Strip all tags
        var text = $("<div></div>").html(str).text();

        // Return the legal tags
        text = text.replace(/_!_BR_!_/g, "<br/>");
        text = text.replace(/_!_U_!_/g, "<u>").replace(/_!_\/U_!_/g, "</u>");
        text = text.replace(/_!_B_!_/g, "<b>").replace(/_!_\/B_!_/g, "</b>");

        return text;
    } else {
        // TODO
    }

    return str;
};

self.nop = function () {
    return function () {};
};

//return self;
exports.default = self;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/Utils.js
// module id = 184
// module chunks = 0